import React from 'react';
import '../pages/DefendantList.css';

const CheckinList = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Check-ins</h1>
          <p className="page-subtitle">Monitor defendant check-in compliance</p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <p className="text-center" style={{ padding: '40px' }}>
            Check-in monitoring feature coming soon. This will display all check-in records with GPS locations and compliance status.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckinList;
